// extracted by mini-css-extract-plugin
export var container = "ThreeUpItem-module--container--37b5d";
export var notThree = "ThreeUpItem-module--notThree--a3699";